import { render, staticRenderFns } from "./SettingTestSet.vue?vue&type=template&id=6391bc60&scoped=true&"
import script from "./SettingTestSet.vue?vue&type=script&lang=js&"
export * from "./SettingTestSet.vue?vue&type=script&lang=js&"
import style0 from "./SettingTestSet.vue?vue&type=style&index=0&id=6391bc60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6391bc60",
  null
  
)

export default component.exports